import { Component } from '@angular/core';
import { BankService } from '../../services/bank.service';
import { BankAccountTypesService } from '../../services/bank_account_type';
import { UserBankInformationService } from '../../services/user_bank_information';
import { UserService } from '../../../user/services/user.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-add-edit-user-bank-information',
  templateUrl: './add-edit-user-bank-information.component.html',
  styleUrl: './add-edit-user-bank-information.component.scss'
})
export class AddEditUserBankInformationComponent {
  banks: any[] = [];
  bankAccountTypes: any[] = [];
  userId:string=''
  userRole:string=''
  existsBankInfo: boolean = false;
  bankInfoId: string = '';

  bankInfoForm = {
    userId:'',
    bank: '',
    bank_account_type: '',
    bank_account_number: ''
  };

  // Propiedades privadas para los servicios
  private userService: UserService;
  private bankService: BankService;
  private bankAccountTypesService: BankAccountTypesService;
  private userBankInformationService: UserBankInformationService;

  constructor(
    userService: UserService,
    bankService: BankService,
    bankAccountTypesService: BankAccountTypesService,
    userBankInformationService: UserBankInformationService
  ) {
    this.userService = userService;
    this.bankService = bankService;
    this.bankAccountTypesService = bankAccountTypesService;
    this.userBankInformationService = userBankInformationService;
  }

  ngOnInit() {
    this.loadBanks();
    this.loadBankAccountTypes();
    this.loadUserInfo();
    this.loadUserBankInformation();
  }

  loadUserInfo() {
    this.userRole=this.userService.getUserRole();
    this.userId=this.userService.getselectedUserId();
    this.bankInfoForm.userId=this.userId;
    if(this.userRole=='Administrador'){
      //recibir el id del usuario
    }
  }
  loadBanks() {
    this.bankService.get().subscribe({
      next: (banks: any[]) => {
        this.banks = banks;
      },
      error: (error) => {
        console.error('Error al cargar los bancos:', error);
        Swal.fire('Error', 'No se pudieron cargar los bancos.', 'error');
      }
    });
  }

  loadBankAccountTypes() {
    this.bankAccountTypesService.get().subscribe({
      next: (types: any[]) => {
        this.bankAccountTypes = types;
      },
      error: (error) => {
        console.error('Error al cargar los tipos de cuenta:', error);
        Swal.fire('Error', 'No se pudieron cargar los tipos de cuenta.', 'error');
      }
    });
  }

  loadUserBankInformation() {
    this.userBankInformationService.getByUserId(this.userId
    ).subscribe({
      next: (info: any) => {
        if (info) {
          this.existsBankInfo = true;
          this.bankInfoForm.bank = info.bank;
          this.bankInfoForm.bank_account_type = info.bank_account_type;
          this.bankInfoForm.bank_account_number = info.bank_account_number;
          this.bankInfoId = info._id;
        } else {
          this.existsBankInfo = false;
          Swal.fire('Info', 'No se encontró información bancaria para el usuario. Favor Agregarla', 'info');
        }
        // Puedes asignar a una propiedad si deseas mostrar la info en el formulario
      },
      error: (error) => {
        console.error('Error al obtener la información bancaria del usuario:', error);
        Swal.fire('Error', 'No se pudo obtener la información bancaria del usuario.', 'error');
      }
    });
  }

  saveBankInfo() {
    Swal.fire({
            title: 'Guardando Datos...',
            html: 'Por favor espera un momento.',
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
    this.userBankInformationService.save(this.bankInfoForm).subscribe({
      next: (response) => {
        console.log('Información bancaria guardada:', response);
        Swal.close();
        Swal.fire('Éxito', 'La información bancaria ha sido guardada correctamente.', 'success');
      },
      error: (error) => {
        Swal.close();
        console.error('Error al guardar la información bancaria:', error);
        Swal.fire('Error', 'No se pudo guardar la información bancaria.', 'error');
      }
    });
  }
  updateBankInfo() {
    Swal.fire({
      title: 'Actualizando Datos...',
      html: 'Por favor espera un momento.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
    this.userBankInformationService.update(this.bankInfoId, this.bankInfoForm).subscribe({
      next: (response) => {
        Swal.close();
        console.log('Información bancaria actualizada:', response);
        Swal.fire('Éxito', 'La información bancaria ha sido actualizada correctamente.', 'success');
      },
      error: (error) => {
        Swal.close();
        console.error('Error al actualizar la información bancaria:', error);
        Swal.fire('Error', 'No se pudo actualizar la información bancaria.', 'error');
      }
    }); 
  }

  onSubmit() {
    if (!this.bankInfoForm.bank || !this.bankInfoForm.bank_account_type || !this.bankInfoForm.bank_account_number || !this.userId) {
      Swal.fire('Error', 'Todos los campos son obligatorios.', 'error');
      console.log(this.bankInfoForm);
      return;
    }
    if (this.existsBankInfo) {
      // Actualizar información bancaria
      this.updateBankInfo();
    }
    else {
      // Guardar nueva información bancaria
      this.saveBankInfo();
    }
    // Aquí podrías hacer la llamada al servicio para guardar
    console.log('Datos del formulario:', this.bankInfoForm);

    Swal.fire('Éxito', 'La información bancaria ha sido guardada correctamente.', 'success');
  }

}
